import {SVG} from '../../../constants/assetLists';
import useText from '../../../hooks/useText';
import {useOnBoardingLogout} from '../../../hooks/useOnBoardingLogout';
import FullScreenLoader from '../../common/FullScreenLoader';

type Props = {
  handleMenuOpenClose?: (state: boolean) => void;
};

function LogoutOption({handleMenuOpenClose}: Props) {
  const t = useText();
  const {handleLogout, isLoggingOut} = useOnBoardingLogout();

  const onLogoutClick = () => {
    handleMenuOpenClose?.(false);
    void handleLogout();
  };

  return (
    <>
      <FullScreenLoader open={isLoggingOut} />

      <div
        className={`flex items-center gap-4 rounded-[16px] text-decoration-none transition-opacity duration-200 hover:opacity-50`}
        onClick={onLogoutClick}>
        <div className="w-[24px] h-[24px]">
          <img
            src={SVG.logoutIcon}
            alt="icon"
            className="w-full h-full object-contain"
          />
        </div>
        <span className={`lg:hidden text-sm font-medium text-gray50`}>
          {t('common.logout')}
        </span>
      </div>
    </>
  );
}

export default LogoutOption;
